import { css } from "styled-components";
import { Color, brightness, form, invert } from "@glossy";
import { GlossyTheme } from "@glossy/theme/types";

interface IProps {
  theme: GlossyTheme;
}

const Colors = {
  operator: {
    Dark: invert("#00F"),
    Light: "#00F",
  },
  parent: {
    Dark: invert("#00F"),
    Light: "#00F",
  },
  phrase: {
    Dark: invert("#A50"),
    Light: "#A50",
  },
  boost: {
    Dark: invert("#164"),
    Light: "#164",
  },
  regex: {
    Dark: invert("#708"),
    Light: "#708",
  },
  field: {
    Dark: invert(Color.LightSeaGreen),
    Light: Color.LightSeaGreen,
  },
};

const isBrightness = (props: IProps): boolean =>
  brightness(form(props, "primary")) >= 0.7;

const getColor = (
  type: "operator" | "parent" | "phrase" | "boost" | "field" | "regex"
) => (props: IProps) => {
  if (isBrightness(props)) {
    return Colors[type].Dark;
  } else {
    return Colors[type].Light;
  }
};

export const tokenHighlights = css<IProps>`
  .cm-operator {
    color: ${getColor("operator")};
  }

  .cm-paren {
    color: ${getColor("parent")};
  }

  .cm-phrase {
    color: ${getColor("phrase")};
  }

  .cm-boost {
    color: ${getColor("boost")};
  }

  .cm-regex {
    color: ${getColor("regex")};
  }

  .cm-field {
    color: ${getColor("field")};
  }
`;
